// src/pages/Appli/AppliAdmin/clubs-admin/utils/clubsAdmin.utils.js

export function normalizeText(value = "") {
  return String(value)
    .normalize("NFD")
    .replace(/\p{Diacritic}/gu, "")
    .toLowerCase()
    .trim();
}

export function pluralize(value, singular, plural) {
  const count = Number(value || 0);

  return `${count} ${count > 1 ? plural : singular}`;
}

export function normalizeWebsiteUrl(url = "") {
  const trimmedUrl = String(url).trim();

  if (!trimmedUrl) return "";

  return /^https?:\/\//i.test(trimmedUrl)
    ? trimmedUrl
    : `https://${trimmedUrl}`;
}

export function getClubSearchText(club = {}) {
  return [
    club.nom_club,
    club.numero_club,
    club.email_club,
    club.site_club,
    club.adresse_club,
    club.tel_club,
    club.departement_club,
  ]
    .filter(Boolean)
    .join(" ");
}

export function getUniqueDepartments(clubs = []) {
  return Array.from(
    new Set(
      clubs
        .map((club) => club?.departement_club)
        .filter(Boolean),
    ),
  ).sort((firstDepartment, secondDepartment) =>
    String(firstDepartment).localeCompare(String(secondDepartment), "fr", {
      numeric: true,
      sensitivity: "base",
    }),
  );
}

export function formatMemberCount(count) {
  if (count === null || count === undefined) return "—";

  const numericCount = Number(count);

  if (!Number.isFinite(numericCount)) return "—";

  return numericCount > 999 ? "999+" : String(numericCount);
}